import React from 'react';

export const BackChevronIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg className={className} width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.69995 0.700001L0.699951 6.7L6.69995 12.7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
